import React from 'react'
import classes from './SubjectModal.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Modal, Typography } from '@mui/material'
import { SelectField } from '../../../../../../components'
import { setLoader, setOpenAddSubject, setSchoolDInfo } from '../../../../../../redux/globalSlice'
import TextField from '../../../../../../components/TextField/Textfield'
import { toast } from 'react-toastify'
import axios from 'axios'
import { baseURL, urls } from '../../../../../../shared/config'
const SubjectModal = ({ open, school_id, refetch }) => {
  const attendanceStatus = ['Active', 'Inactive']

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 471,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '24px', // optional: looks better
  }
  const selectedRow = useSelector((state) => state.global.SchoolDInfo)
  console.log('---selectedRow', selectedRow)

  const isEdit = useSelector((state) => state.global.isEdit)
  const [formValues, setFormValues] = React.useState({
    school_id: school_id,
    subject_name: isEdit ? selectedRow?.subject_name : '',
    subject_short_form: isEdit ? selectedRow?.subject_short_form : '',
    // status: 'Active',
  })

  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(setOpenAddSubject(false))
    dispatch(setSchoolDInfo(null))
  }

  const handleSubmit = async () => {
    dispatch(setLoader(true))
    try {
      const responseBody = isEdit
        ? {
            subject_id: selectedRow?.subject_id,
            ...formValues,
          }
        : {
            ...formValues,
          }
      const response = isEdit
        ? await axios.patch(`${baseURL}${urls.SUBJECT}`, responseBody)
        : await axios.post(`${baseURL}${urls.SUBJECT}`, responseBody)

      if (response?.data?.status === 201 || response?.data?.status === 200) {
        toast.success('Subject Added Successfully')
      } else {
        toast.error('Some Error Has Occured, Please try later')
      }
    } catch (error) {
      console.error(error)
      toast.error('Some Error Has Occured, Please try later')
    } finally {
      dispatch(setLoader(false))
      handleClose()
      refetch()
    }
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={classes.container}>
          <div className="header-registration">
            <p className="modalheadtxt">Add New Subject</p>
          </div>
          <TextField
            placeholder="eg, for teacher or for a class"
            value={formValues.subject_name}
            onChange={(e) => setFormValues({ ...formValues, subject_name: e.target.value })}
            label="Subject Name"
            required={true}
            width="100%"
          />
          <TextField
            placeholder="eg, for teacher or for a class"
            value={formValues.subject_short_form}
            onChange={(e) => setFormValues({ ...formValues, subject_short_form: e.target.value })}
            label="Subject Short Form"
            required={true}
            width="100%"
          />
          {/* <SelectField
            placeholder={''}
            value={formValues?.status}
            onChange={(selectedOption) => setFormValues({ ...formValues, status: selectedOption })}
            label={'Status'}
            required={true}
            width={'100%'}
            statusProp={true}
            options={(attendanceStatus || [])?.map((item) => ({
              value: item,
              label: item,
            }))}
          /> */}

          <div className={classes.bottom}>
            <button onClick={handleClose} className={`${classes.flex} white-button`}>
              {'Cancel'}
            </button>

            <button onClick={handleSubmit} className={`${classes.flex} primary-button`}>
              {'Confirm'}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default SubjectModal
